import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'scroll',
    ...theme.scrollbarStyles
  },
  buttonNewAnnouncement: {
    backgroundColor: theme.palette.green_200.main,
    color: '#fff',
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none'
    }
  },
  searchInput: {
    '& .MuiOutlinedInput-input': {
      padding: '10px 12px',
      borderRadius: '8px',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  }
}))
